export default "__VITE_ASSET__b1c2d852__"